import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import http from './request/api.js'
import '../src/assets/css/flex.css'
import '../src/assets/css/variables.css'
// import '../src/assets/css/reset.css'
import i18n from './i18n/i18n'
import Footer from '@/components/Footer'
import Header from '@/components/Header'
import ArticleList from '@/components/ArticleList'
import ArticleDetail from '@/components/ArticleDetail'


Vue.config.productionTip = false
Vue.prototype.$api = http;
Vue.use(ElementUI)
Vue.component('Header', Header)
Vue.component('Footer', Footer)
Vue.component('ArticleList', ArticleList)
Vue.component('ArticleDetail', ArticleDetail)

new Vue({
  i18n,//注意此处
  router,
  store,

  render: h => h(App)
}).$mount('#app')
